<template>
  <v-row no-gutters class="mt-3">
    <v-col cols="12" class="colSearchInput">
      <label class="font-weight-bold" for="select" v-if="label">{{
        label
      }}</label>
      <v-autocomplete
        :menu-props="{
          nudgeBottom: '0px'
        }"
        v-model="select"
        no-filter
        :loading="loading"
        :items="searchResult"
        item-text="name"
        item-value="id"
        return-object
        :search-input.sync="search"
        flat
        hide-no-data
        hide-details="auto"
        :placeholder="placeholder"
        solo
        :append-icon="iconAppend"
        append-item
        :outlined="outlined"
        :dense="dense"
        :disabled="disabled"
        :multiple="multiple"
        chips
        deletable-chips
        :rules="rules"
      >
        <template slot="no-data">
          <translate class="ml-3">No data available</translate>
        </template>
        <template v-slot:selection="{ index }" v-if="multiple">
          <span v-if="index === 0" class="autocomplte-cation">
            <template v-if="select.length === 1">
              ({{ select.length }} selected) &nbsp;
            </template>
            <template v-else>({{ select.length }} selected) &nbsp;</template>
          </span>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="grey"
                class="ml-2 btn__deleteAll"
                size="24"
                v-bind="attrs"
                v-on="on"
                style="position: absolute; right: 40px"
                @click="remove('all')"
              >
                fal fa-xmark
              </v-icon>
            </template>
            <translate>Delete all</translate>
          </v-tooltip>
        </template>
        <template v-slot:item="data">
          <AvatarComponent
            size="40"
            :url="data.item.picture"
            class="mr-4"
            v-if="isUser"
          />
          <span>{{ data.item.text }}</span>
        </template>
        <div
          slot="append-item"
          class="infiniteScroll text-center"
          id="infiniteScroll"
          v-show="totalPages > currentPage"
        >
          <v-btn
            text
            color="primary"
            class="text-decoration-underline font-weight-bold"
            @click="getListData({ page: (currentPage += 1) })"
          >
            <translate>See More</translate>
          </v-btn>
        </div>
      </v-autocomplete>
      <div
        class="autocomplete-chip"
        v-if="select && select.length > 0 && multiple"
      >
        <template v-for="(val, key) in select">
          <v-chip class="mr-2 mt-2" :key="key" color="white"
            >{{ val.text }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="red"
                  class="ml-2"
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="remove(val)"
                >
                  fas fa-xmark
                </v-icon>
              </template>
              <span><translate>Delete</translate></span>
            </v-tooltip>
          </v-chip>
        </template>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import { debounce } from "@/utils/helper";
export default {
  name: "SelectMultiCourse",
  props: {
    name: { type: String },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    iconAppend: { type: String, default: "" },
    outlined: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    value: {},
    rules: {},
    city: {},
    state: {},
    action: { type: String, default: "" },
    multiple: {},
    isEmit: { type: Boolean, default: false },
    isPushLink: { type: Boolean, default: false },
    isCourse: { type: Boolean, default: false },
    isUser: { type: Boolean, default: false },
  },
  data: () => ({
    loading: false,
    items: [],
    search: null,
    select: null,
    timeout: null,
    searchResult: [],
    totalPages: 1,
    currentPage: 1,
    text: null
  }),
  computed: {},
  mounted() {
    if (this.value) {
      this.select = this.value;
      let list = this.value;
      if (list.length && list.length !== 0) {
        list.forEach((element) => {
          element.text = this.getText(element);
        });
      } else {
        // when in post form value is a object
        list.text = this.getText(list);
      }
      this.searchResult = this.searchResult.concat(list);
    }
  },
  methods: {
    querySelections: debounce(async function (v) {
      this.text = v;
      if (this.value && v === this.value.name) {
        return;
      }
      await this.getListData({ page: 1 });
    }, 1000),
    async getListData(data) {
      this.currentPage = data.page;
      if (this.totalPages !== 1 && this.currentPage > this.totalPages) {
        return;
      }
      this.loading = true;
      const result = await this.$store.dispatch(this.action, {
        text: this.text,
        city: this.city,
        state: this.state,
        page: data.page,
      });
      if (result.list && result.list.length !== 0) {
        let list = result.list;
        list.forEach((element) => {
          element.text = this.getText(element);
        });
        if (
          result.currentPage <= result.totalPages &&
          result.currentPage !== 1
        ) {
          this.searchResult = this.searchResult.concat(list);
        } else {
          this.searchResult = list;
        }
      } else {
        this.searchResult = [];
      }
      this.totalPages = result.totalPages || 1;
      this.currentPage = result.currentPage;
      this.loading = false;
    },
    getText(element) {
      if (this.isUser) {
        return element.firstName + " " + element.lastName;
      } else {
        return (
          element.name +
          " ( " +
          element.country.name +
          " / " +
          element.state +
          " / " +
          element.city +
          " ) "
        );
      }
    },
    remove(item) {
      if (item === "all") {
        this.select = [];
      } else {
        const index = this.select.indexOf(item);
        if (index >= 0) {
          this.select.splice(index, 1);
        }
      }
    },
    reset() {
      this.searchResult = [];
      this.select = [];
    },
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    },
    value: {
      handler(val) {
        this.select = val;
        if (val && val.length === 0) {
          this.searchResult = [];
        }
      },
    },
    select: {
      handler(val) {
        if (this.isPushLink) {
          if (this.isCourse) {
            this.$router.push({
              name: "courses.home",
              params: {
                coursesCountry: val.country.slug,
                namegolf: val.slug,
              },
            });
          }
          if (this.isUser) {
            this.$router.push({
              name: "profilePerson",
              params: { key: val.id },
            });
          }
        } else if (this.isEmit) {
          this.$emit("getSelected", this.select);
        } else {
          this.$emit("input", val);
        }
      },
    },
  },
};
</script>

<style lang="scss">
.colSearchInput {
  .autocomplete-chip {
    background-color: rgb(238, 238, 238);
    margin-top: 5px;
    padding: 5px 10px 10px;
    span {
      max-width: 100%;
      white-space: pre-line;
      height: auto;
      min-height: 32px;
    }
  }
}

.v-autocomplete:not(.v-input--is-focused).v-select--chips input {
  max-height: unset !important;
}
.btn__deleteAll {
  z-index: 1;
}
</style>
